import { render, staticRenderFns } from "./ProductCardList.vue?vue&type=template&id=57b27e36&"
import script from "./ProductCardList.vue?vue&type=script&lang=js&"
export * from "./ProductCardList.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports